import { defineMessages } from 'react-intl';

export default defineMessages({
  approvalsNavItem_awaiting: {
    id: 'app.approvals.nav.awaiting',
    defaultMessage: 'Awaiting Approval',
  },
  approvalsNavItem_awaiting_tooltipHeader: {
    id: 'app.approvals.nav.awaiting.tooltipHeader',
    defaultMessage: "What's this?",
  },
  approvalsNavItem_awaiting_tooltipText: {
    id: 'app.approvals.nav.awaiting.tooltipText',
    defaultMessage:
      'Once you approve a product, the person who made it will be able to order. If they make any changes they will resubmit to you for approval.',
  },
  approvalsDropdownLabel: {
    id: 'app.approvals.dropdown.label',
    defaultMessage: 'Select Approval View',
  },
  approvalsDashboardRequestedByLabel: {
    id: 'app.approvals.dashboard.requestedBy.label',
    defaultMessage: 'Requested by',
  },
  approvalsDashboardProductLabel: {
    id: 'app.approvals.dashboard.product.label',
    defaultMessage: 'Product',
  },
  approvalsDashboardPaperLabel: {
    id: 'app.approvals.dashboard.paper.label',
    defaultMessage: 'Paper',
  },
  approvalsDashboardApproveButtonText: {
    id: 'app.approvals.dashboard.approval.button.text',
    defaultMessage: 'Approve',
  },
  approvalsDashboardDeclineButtonText: {
    id: 'app.approvals.dashboard.decline.button.text',
    defaultMessage: 'Decline',
  },
  approvalsDashboardOnText: {
    id: 'app.approvals.dashboard.approval.on.text',
    defaultMessage: 'on',
  },
  approvalsDashboardPreviewTooltipText: {
    id: 'app.approvals.dashboard.preview.tooltip.text',
    defaultMessage: 'Preview',
  },
  approvalsDashboardEditTooltipText: {
    id: 'app.approvals.dashboard.edit.tooltip.text',
    defaultMessage: 'Edit',
  },
  approveDialogTitle: {
    id: 'app.dialog.approval.approve.title',
    defaultMessage: 'Ready to approve this product?',
  },
  approveDialogDescription: {
    id: 'app.dialog.approval.approve.description',
    defaultMessage:
      'Once approved, {employeeName} will be able to order their {productType}. If they make any changes they will resubmit to you for approval.',
  },
  approveDialogButtonApprove: {
    id: 'app.dialog.approval.button.approve',
    defaultMessage: 'Approve',
  },
  approvalDialogButtonCancel: {
    id: 'app.dialog.approval.button.cancel',
    defaultMessage: 'Cancel',
  },
  declineDialogTitle: {
    id: 'app.dialog.approval.decline.title',
    defaultMessage: 'Decline this product',
  },
  declineDialogDescription: {
    id: 'app.dialog.approval.decline.description',
    defaultMessage:
      'Please tell {employeeName} why you’re declining their product and what they need to edit for approval.',
  },
  approveDialogButtonDecline: {
    id: 'app.dialog.approval.button.decline',
    defaultMessage: 'Decline',
  },
  approveDialogReasonFieldPlaceholder: {
    id: 'app.dialog.approval.reason.placeholder',
    defaultMessage: 'Your message...',
  },
  noApprovalsTitle: {
    id: 'app.approvals.dashboard.noApprovals.title',
    defaultMessage: 'All up to date',
  },
  noApprovalsText: {
    id: 'app.approvals.dashboard.noApprovals.text',
    defaultMessage: 'Looks like there’s nothing to do right now. All approval requests will appear here.',
  },
  approveDialogReasonFieldCounterTextLimitMessage: {
    id: 'app.dialog.approval.counter.limit.message',
    defaultMessage: 'You have {count} {count, plural, one {character} other {characters}} remaining',
  },
  approveDialogReasonFieldCounterTextLimitExceededMessage: {
    id: 'app.dialog.approval.counter.limit.exceeded.message',
    defaultMessage: 'You have {overCount} {overCount, plural, one {character} other {characters}} too many',
  },
});
